import { CheckIcon } from "@heroicons/react/20/solid"
import H2 from "components/atoms/H2"
import ScrollAnimate from "components/atoms/common/ScrollAnimate"
import useTranslations from "hooks/useTranslations"
import { BadgeImage } from "./images"

/**
 * Whole-school benefits, with the "Protected by SomeBuddy" badge beside them.
 *
 * Not built on Divided like the other sections: Divided always masks its image
 * into a rounded-l-full frame, which suits photography but would clip the
 * badge's own circular edge. The badge sits free on the dark ground instead.
 */
export default function ParentInfoCulture() {
  const {
    parentInfoCultureTitle,
    parentInfoCultureLead,
    parentInfoCultureIntro,
    parentInfoCultureItems,
    parentInfoCultureOutro,
  } = useTranslations()

  const items: string[] = parentInfoCultureItems || []

  return (
    <div className="bg-zinc-800 py-16 lg:py-24">
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-y-12 lg:grid-cols-2 lg:gap-x-16">
          <div className="space-y-8">
            <H2
              size="lg"
              className="m-0 whitespace-pre-line text-left font-extrabold tracking-tight"
              theme="dark"
            >
              {parentInfoCultureTitle}
            </H2>
            <p className="m-0 font-display text-lg leading-tight text-zinc-300 lg:text-xl">
              {parentInfoCultureLead}
            </p>
            <p className="m-0 text-base text-zinc-200">
              {parentInfoCultureIntro}
            </p>
            <ul className="m-0 list-none space-y-4 p-0">
              {items.map((item, index) => (
                <ScrollAnimate key={item} delay={index * 0.08}>
                  <li className="flex items-start gap-3">
                    <CheckIcon
                      aria-hidden="true"
                      className="mt-0.5 h-6 w-6 shrink-0 text-kkm-green"
                    />
                    <span className="text-base leading-snug text-zinc-100 lg:text-lg">
                      {item}
                    </span>
                  </li>
                </ScrollAnimate>
              ))}
            </ul>
            <p className="m-0 text-base text-zinc-200">
              {parentInfoCultureOutro}
            </p>
          </div>
          {/* order-first puts the badge above the text on mobile, matching
              where the other sections place their image. */}
          <div className="order-first flex justify-center lg:order-last">
            <BadgeImage className="w-full max-w-xs sm:max-w-sm lg:max-w-lg" />
          </div>
        </div>
      </section>
    </div>
  )
}
